export const LANGUAGE_CHANGED_EN = "LANGUAGE_CHANGED_EN";
export const LANGUAGE_CHANGED_FR = "LANGUAGE_CHANGED_FR";

export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const BOOKS_FETCHED = "BOOKS_FETCHED";
export const BOOK_CREATED = "BOOK_CREATED";